import { gql } from '@apollo/client'
import INTERACTIONS from 'apollo/queries/INTERACTIONS'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation createInteraction($attributes: CreateInteractionAttributesInput!) {
    createInteraction(attributes: $attributes) {
      id
      ticket {
        id
      }
    }
  }
`

export default function useInteractionCreate(successMessage = '') {
  const { onMutate: onInteractionCreate, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'createInteraction',
    successMessage,
    refetchQueries: ({ data }) => {
      const ticketId = data?.createInteraction?.ticket?.id
      if (!ticketId) return null

      return [
        {
          query: INTERACTIONS,
          variables: {
            first: 25,
            filters: {
              ticket_ids: [ticketId]
            }
          }
        }
      ]
    }
  })

  return { onInteractionCreate, loading }
}
